export const getSortingLinkManual = state => {
  return state.link_manual
}



// WEBPACK FOOTER //
// ./src/store/modules/sort_options/getters.js